import {Loner} from "../../../Loner";
import {gsap} from "gsap";

export class LonerPinTheWinBg extends PIXI.Container {
    private _fullBody: PIXI.Sprite;
    private _eyesContainer: PIXI.Container;
    private _movingEyes: PIXI.Sprite;
    private _upperEyesPart: PIXI.Sprite;
    private _eyeMovementPositions: number[][][] = [];

    constructor() {
        super();
        this.name = "LonerPinTheWinBg";
        this.init();
        this.fillEyeMovementPosition();
        this._eyesContainer.addChild(this._movingEyes, this._upperEyesPart);
        this.addChild(this._fullBody, this._eyesContainer);
    }

    public showAllAssets(durr: number = 0.5): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this._fullBody.alpha = 0;
            this._eyesContainer.alpha = 0;
            this._fullBody.visible = true;
            this._eyesContainer.visible = true;
        })
        tl.to([this._fullBody, this._eyesContainer], {alpha: 1, duration: durr, ease: "none"});
        return tl;
    }

    public hideAllAssets(durr: number = 0.5): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.to([this._fullBody, this._eyesContainer], {alpha: 0, duration: durr, ease: "none"});
        tl.add(() => {
            this._fullBody.visible = false;
            this._eyesContainer.visible = false;
        })
        return tl;
    }

    public moveEyes(destReelIdc: number, destSymIdc: number, time: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(gsap.to(this._movingEyes, {
            x: this._eyeMovementPositions[destReelIdc][destSymIdc][0],
            y: this._eyeMovementPositions[destReelIdc][destSymIdc][1],
            duration: time,
            ease: "none"
        }))
        return tl;
    }

    public setCurrentPosOfEyes(destReelIdc: number, destSymIdc: number): void {
        this._movingEyes.position.set(this._eyeMovementPositions[destReelIdc][destSymIdc][0], this._eyeMovementPositions[destReelIdc][destSymIdc][1]);
    }

    private init(): void {
        this._fullBody = this.createFullBodySprite();
        this._movingEyes = this.createMovingEyes();
        this._upperEyesPart = this.createUpperEyesPart();
        this._eyesContainer = this.createEyesContainer();
    }

    private createEyesContainer(): PIXI.Container {
        const cont: PIXI.Container = new PIXI.Container();
        cont.name = "eyesContainer";
        cont.position.set(360, 276);
        cont.visible = false;
        cont.alpha = 0;
        return cont;
    }

    private createFullBodySprite(): PIXI.Sprite {
        const sprite: PIXI.Sprite = new PIXI.Sprite(Loner.assetLoader.getTextures("SpinSpinSpin/man")[0]);
        sprite.name = "bodySprite";
        sprite.anchor.set(0.5);
        sprite.position.set(360, 360);
        sprite.visible = false;
        sprite.alpha = 0;
        return sprite;
    }

    private createMovingEyes(): PIXI.Sprite {
        const sprite: PIXI.Sprite = new PIXI.Sprite(Loner.assetLoader.getTextures("SpinSpinSpin/EyeBall")[0]);
        sprite.name = "eyeBalls";
        sprite.anchor.set(0.5);
        sprite.position.set(0);
        return sprite;
    }

    private createUpperEyesPart(): PIXI.Sprite {
        const sprite: PIXI.Sprite = new PIXI.Sprite(Loner.assetLoader.getTextures("SpinSpinSpin/manUpperEye")[0]);
        sprite.name = "eyeBallUpperPart";
        sprite.anchor.set(0.5);
        sprite.position.set(0);
        return sprite;
    }

    private fillEyeMovementPosition(): void {
        this._eyeMovementPositions = [
            [[-10, -10], [-10, -5], [-10, 6], [-10, 8], [-10, 10]],
            [[-6, -10], [0, 0], [0, 0], [0, 0], [-2, 10]],
            [[0, -10], [0, 0], [0, 0], [0, 0], [0, 10]],
            [[7, -10], [0, 0], [0, 0], [0, 0], [5, 10]],
            [[10, -10], [10, -5], [10, 6], [10, 8], [10, 10]]
        ]
    }
}